import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { navigate("/admin"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setUser(data);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: data }, replace: true });
      } catch {
        navigate("/admin", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F9F6F0]">
      <p className="text-[#5C6370]">Connexion en cours…</p>
    </div>
  );
}
